import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { Events } from 'ionic-angular';

/**
 * Generated class for the UserlinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-userlin',
  templateUrl: 'userlin.html',
})
export class UserlinPage {
  muestragif = "";
  imagenobtenida;
  imagenes;
  imaahora;
  grupoid;
  tabla;
  caption: string;
  pages;
  pages2;
  rsx;
  v;
  myForm: FormGroup;
  formulario = { valor: '' }
  usuarioregistroarray;

  constructor(
  	public navCtrl: NavController,
  	public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public params: NavParams,
    public viewCtrl: ViewController,
    public variables:VariablesProvider,
    public events: Events
    ) {
    
    this.caption = params.get('caption');
    this.grupoid = params.get('valor');
    this.tabla = params.get('tabla');
    this.rsx = params.get('rsx');
    this.v = params.get('id');
    this.usuarioregistroarray = params.get('usuarioregistroarray');
    



    this.myForm = this.fb.group({
      nombre: [this.rsx[this.v].NOMBRE, [Validators.required]],
      razsocial: [this.rsx[this.v].RAZSOCIAL, [Validators.required]],
      nif: [this.rsx[this.v].CIF, [Validators.required, Validators.pattern(/^[a-zA-Z0-9_-]{9,9}$/)]],
      email: [this.rsx[this.v].EMAIL, [Validators.required, Validators.email]],
      contrasena: [this.rsx[this.v].PASS, [Validators.required, Validators.pattern(/^[a-zA-Z0-9_-]{6,18}$/)]],
      telefono: [this.rsx[this.v].TELEFONO, [Validators.pattern(/^[0-9_-]{9,11}$/)]],
      direccion: [this.rsx[this.v].DIRECCION, Validators.required],
      cpostal: [this.rsx[this.v].CPOSTAL, [Validators.pattern(/^[0-9_-]{5,5}$/)]],
      poblacion: [this.rsx[this.v].POBLACION],
      provincia: [this.rsx[this.v].PROVINCIA],
      pais: [this.rsx[this.v].PAIS],
      logo: [this.rsx[this.v].LOGO],
      color: [this.rsx[this.v].COLOR],
      estado: [this.rsx[this.v].ESTADO],
    });


    this.myForm.value.color = this.rsx[this.v].COLOR;

    //console.log(this.rsx[this.v].VALOR);


    this.pages = [];
    this.pages.push ({ title: 'Inicio', visible: this.rsx[this.v].VALOR.slice(0, 1)});
    this.pages.push ({ title: 'Trabajadores y grupos', visible: this.rsx[this.v].VALOR.slice(1, 2)});  
    this.pages.push ({ title: 'Empresas', visible: this.rsx[this.v].VALOR.slice(2, 3)});
    this.pages.push ({ title: 'Obras', visible: this.rsx[this.v].VALOR.slice(3, 4)});
    this.pages.push ({ title: 'Turnos', visible: this.rsx[this.v].VALOR.slice(4, 5)});        
    this.pages.push ({ title: 'Fiestas', visible: this.rsx[this.v].VALOR.slice(5, 6)});
    this.pages.push ({ title: 'Reservas', visible: this.rsx[this.v].VALOR.slice(6, 7)});
    this.pages.push ({ title: 'User', visible: this.rsx[this.v].VALOR.slice(7, 8)});
    
    //console.log(this.rsx[this.v].VALOR2);

    this.pages2 = [];
    this.pages2.push ({ title: 'picajes', visible: this.rsx[this.v].VALOR2.slice(0, 1)});
    this.pages2.push ({ title: 'Ticket', visible: this.rsx[this.v].VALOR2.slice(1, 2)});  
    this.pages2.push ({ title: 'albaranes', visible: this.rsx[this.v].VALOR2.slice(2, 3)});
    this.pages2.push ({ title: 'reservas', visible: this.rsx[this.v].VALOR2.slice(3, 4)});
    this.pages2.push ({ title: 'vacaciones', visible: this.rsx[this.v].VALOR2.slice(4, 5)});     

  }

  ionViewDidLoad() {
   


  }


cambiavisible(i,valor) {

var texto = this.rsx[this.v].VALOR;

//console.log("Valor anterior:" + texto);

switch (i) {
  case 0:
    this.pages[0].visible= valor;
    texto =  valor + texto.slice(1, 8);;
    //console.log("Nuevo valor" + texto);
    break;
  case 1:
    this.pages[1].visible= valor;
    texto =  texto.slice(0, 1) + valor +  texto.slice(2, 8);
    //console.log("Nuevo valor" + texto);
    break;
  case 2:
    this.pages[2].visible= valor;
    texto =  texto.slice(0, 2) + valor +  texto.slice(3, 8);
    //console.log("Nuevo valor" + texto);
    break;
  case 3:
    this.pages[3].visible= valor;
    texto =  texto.slice(0, 3) + valor +  texto.slice(4, 8);
    //console.log("Nuevo valor" + texto);
    break;
  case 4:
    this.pages[4].visible= valor;
    texto =  texto.slice(0, 4) + valor +  texto.slice(5, 8);
    //console.log("Nuevo valor" + texto);
    break;
  case 5:
    this.pages[5].visible= valor;
    texto =  texto.slice(0, 5) + valor +  texto.slice(6, 8);
    //console.log("Nuevo valor" + texto);
    break;
  case 6:
    this.pages[6].visible= valor;
    texto =  texto.slice(0, 6) + valor +  texto.slice(7, 8);
    //console.log("Nuevo valor" + texto);
    break;
  case 7:
    this.pages[7].visible= valor;
    texto =  texto.slice(0, 7) + valor;
    //console.log("Nuevo valor" + texto);
    break;
}

 this.rsx[this.v].VALOR = texto;
  
}


cambiavisible2(i,valor) {

var texto = this.rsx[this.v].VALOR2;

//console.log("Valor anterior:" + texto);

switch (i) {
  case 0:
    this.pages2[0].visible= valor;
    texto =  valor + texto.slice(1, 5);
    //console.log("Nuevo valor" + texto);
    break;
  case 1:
    this.pages2[1].visible= valor;
    texto =  texto.slice(0, 1) + valor +  texto.slice(2,5);
    //console.log("Nuevo valor" + texto);
    break;
  case 2:
    this.pages2[2].visible= valor;
    texto =  texto.slice(0, 2) + valor +  texto.slice(3, 5);
    //console.log("Nuevo valor" + texto);
    break;
  case 3:
    this.pages2[3].visible= valor;
    texto =  texto.slice(0, 3) + valor +  texto.slice(4, 5);
    //console.log("Nuevo valor" + texto);
    break;
  case 4:
    this.pages2[4].visible= valor;
    texto =  texto.slice(0, 4) + valor;
    //console.log("Nuevo valor" + texto);
    break;
}

 this.rsx[this.v].VALOR2 = texto;
  
}


registro() { 

    
    this.variables.usuarioregistroarray = {};
    this.variables.usuarioregistroarray["nombre"] = this.myForm.value.nombre;
    this.variables.usuarioregistroarray["razsocial"] = this.myForm.value.razsocial;
    this.variables.usuarioregistroarray["email"] = this.myForm.value.email;
    this.variables.usuarioregistroarray["contrasena"] = this.myForm.value.contrasena;
    this.variables.usuarioregistroarray["telefono"] = this.myForm.value.telefono;
    this.variables.usuarioregistroarray["direccion"] = this.myForm.value.direccion;
    this.variables.usuarioregistroarray["cpostal"] = this.myForm.value.cpostal;
    this.variables.usuarioregistroarray["poblacion"] = this.myForm.value.poblacion;
    this.variables.usuarioregistroarray["provincia"] = this.myForm.value.provincia;
    this.variables.usuarioregistroarray["nif"] = this.myForm.value.nif;
    this.variables.usuarioregistroarray["pais"] = this.myForm.value.pais;

    this.variables.addRegistro(this.variables.usuarioregistroarray);


    if (this.myForm.dirty && this.myForm.valid) {
        alert(`Correo enviado con los datos de acceso al ${this.myForm.value.email}`);
    }
  }


ponencampo(campo:string, value:string):void{

     switch (campo) {

          case "COLOR":
            this.myForm.value.color = value;
            this.rsx[this.v].VALOR=value;
            

            break;
          default:
             // code...
          break;
         }
 }

dismiss() {

    this.rsx[this.v].NOMBRE = this.myForm.value.nombre;
    this.rsx[this.v].RAZSOCIAL = this.myForm.value.razsocial;    
    this.rsx[this.v].EMAIL = this.myForm.value.email;
    this.rsx[this.v].PASS = this.myForm.value.contrasena;
    this.rsx[this.v].TELEFONO = this.myForm.value.telefono;
    this.rsx[this.v].DIRECCION = this.myForm.value.direccion;
    this.rsx[this.v].CPOSTAL = this.myForm.value.cpostal;
    this.rsx[this.v].POBLACION = this.myForm.value.poblacion;
    this.rsx[this.v].PROVINCIA = this.myForm.value.provincia;
    this.rsx[this.v].CIF = this.myForm.value.nif;
    this.rsx[this.v].PAIS = this.myForm.value.pais;
    this.rsx[this.v].LOGO = this.myForm.value.logo;
    this.rsx[this.v].COLOR = this.myForm.value.color;
    this.rsx[this.v].ESTADO = this.myForm.value.estado;


    this.viewCtrl.dismiss(
      {
        'valornuevo': this.rsx[this.v].VALOR,
        'valornuevo2': this.rsx[this.v].VALOR2,
        'usuario': this.rsx
      }
    ); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/userlin/userlin.ts